import { render, staticRenderFns } from "./ModalCadastraAtividadeDisciplinaDireito.vue?vue&type=template&id=18a5dd34"
import script from "./ModalCadastraAtividadeDisciplinaDireito.vue?vue&type=script&lang=js"
export * from "./ModalCadastraAtividadeDisciplinaDireito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports